import useGeneralStore from "./store";

export default useGeneralStore;
